import { render } from "./tc.vue?vue&type=template&id=14b74d2f"
import script from "./tc.vue?vue&type=script&lang=js"
export * from "./tc.vue?vue&type=script&lang=js"

import "./tc.vue?vue&type=style&index=0&id=14b74d2f&lang=css"

import exportComponent from "/Users/zqj/Documents/git/H5/Website/WaterHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__